import { FC } from 'react'

const LABELS: Record<string, string> = {
  created: 'Created',
  updated: 'Updated',
  deleted: 'Deleted',
  login: 'Login',
  purchased: 'Purchased',
}

export const AuditActionBadge: FC<{ action: string }> = ({ action }) => {
  const label = LABELS[action] || action
  return <span className={`nb-audit__badge nb-audit__badge--${action}`}>{label}</span>
}
